/**
 * Nursing homes domain — utility functions and shared types.
 *
 * Re-exports generated entity types plus the typed adapters that bridge the
 * Kubb-generated shapes to the legacy props expected by `DECommonTable`,
 * `DemographicsSection`, etc. The cross-domain adapters live here (rather
 * than in component files) so the casts are documented and centralized.
 */

import type { AddressInfo } from '../../models/restaurant'
import type { NursingHomeNested } from '../generated/types/NursingHomeNested'

// ── Domain entity type re-exports ───────────────────────────────────

export type { NursingHomeListItem } from '../generated/types/NursingHomeListItem'
export type { NursingHomeNested } from '../generated/types/NursingHomeNested'

// ── Typed adapters for legacy component props ───────────────────────

/**
 * Convert the generated `NursingHomeNested.address_info` (a `VerticalZipCode`
 * shape) into the legacy `AddressInfo` interface that `DemographicsSection`
 * accepts. The runtime data is compatible; this helper makes the type bridge
 * explicit instead of repeating the cast at each call site.
 */
export function toLegacyAddressInfo(
  addressInfo: NursingHomeNested['address_info'] | null | undefined
): AddressInfo | undefined {
  if (!addressInfo) return undefined
  return addressInfo as AddressInfo
}
